/* eslint camelcase: 0 */

import { API_PREFIX, API_SPECIFICATION } from "../constants/index";
import axios from "axios";

import { getUrlParams, addParamToResource } from "./misc";
import * as Sentry from "@sentry/react";
import { decodeJwt } from 'jose'
import _ from "lodash";
import Cookies from "js-cookie";
import CookiesUtils from "./cookies";

export const getAPIPrefix = (version = API_SPECIFICATION) => {
  return `/api/v${version}`;
};

const addLangIfPresent = (resource) => {
  const urlParams = getUrlParams();
  if (urlParams && urlParams.lang) {
    return addParamToResource("lang", urlParams.lang, resource);
  }

  const langCookies = CookiesUtils.getLang();
  if (langCookies) {
    return addParamToResource("lang", langCookies, resource);
  }

  return resource;
};

export async function check_url_exists(
    resource,
    version = API_SPECIFICATION
) {
  try {
    const result = await axios.options(`${getAPIPrefix(version)}/${resource}`);
    if (result.status === 200) {
      return true
    } else {
      return false
    }
  } catch (error) {
    return false
  }
}

export function data_fetch_api_resource(
  token,
  resource,
  version = API_SPECIFICATION
) {
  return axios.get(getAPIPrefix(version) + "/" + addLangIfPresent(resource))
}

export function data_fetch_api_resource_with_params(
  token,
  resource,
  params = {},
  version = API_SPECIFICATION
) {
  return axios
    .get(getAPIPrefix(version) + "/" + addLangIfPresent(resource), {
      params,
    })
}

export function data_download_api_resource(
  token,
  resource,
  version = API_SPECIFICATION
) {
  return axios.get(getAPIPrefix(version) + "/" + addLangIfPresent(resource), {
    responseType: "blob",
  })
}

export const data_create_api_resource = async (
  token,
  resource,
  new_data,
  version = API_SPECIFICATION
) => {
  return axios.post(
    getAPIPrefix(version) + "/" + addLangIfPresent(resource),
    new_data
  );
};

export function data_update_api_resource(
  token,
  resource,
  new_data,
  version = API_SPECIFICATION
) {
  return axios.put(
    getAPIPrefix(version) + "/" + addLangIfPresent(resource),
    new_data
  );
}

export function data_delete_api_resource(
  token,
  resource,
  version = API_SPECIFICATION
) {
  return axios.delete(getAPIPrefix(version) + "/" + addLangIfPresent(resource));
}